module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_f_albino.15a9d208.png";